export default {
  getLayoutComponent(panelEnum) {
    // le api restituiscono direttamente la enum as string che corrisponde al nome del pannello by convention
    return panelEnum;
    // switch (code){
    //   case 1:
    //     return 'CapacityDetails';
    //   case 2:
    //     return 'AirSideDetails';
    //   case 3:
    //     return 'DirectExpansionDetails';
    //   case 4:
    //     return 'CoilsProjectDetails';
    //   case 5:
    //     return 'CondensingDetails';
    // }
    // return '';
  }
};
